import { css } from '@emotion/react';

export const root = css`
  background-color: hsla(var(--color-textLight-2), 10%);
  padding: calc(var(--unit) * 7);
  border-radius: var(--border-radius-medium);
  margin-top: calc(var(--unit) * 10);
  margin-bottom: calc(var(--unit) * 15);
`;
